export const economicOptions = [
    { name: 'Real GDP', code: 'REAL_GDP' },
    { name: 'Real GDP per Capita', code: 'REAL_GDP_PER_CAPITA' },
    { name: 'Treasury Yield', code: 'TREASURY_YIELD' },
    { name: 'Federal Funds (Interest) Rate', code: 'FEDERAL_FUNDS_RATE' },
    { name: 'CPI', code: 'CPI' },
    { name: 'Retail Sales', code: 'RETAIL_SALES' },
    { name: 'Durable Goods Orders', code: 'DURABLES' },
    { name: 'Unemployment Rate', code: 'UNEMPLOYMENT' },
    { name: 'Nonfarm Payroll', code: 'NONFARM_PAYROLL' }
  ];
  
  export const intervalOptionsMap = {
    REAL_GDP: [
      { label: 'Quarterly', value: 'quarterly' },
      { label: 'Annual', value: 'annual' }
    ],
    TREASURY_YIELD: [
      { label: 'Daily', value: 'daily' },
      { label: 'Weekly', value: 'weekly' },
      { label: 'Monthly', value: 'monthly' }
    ],
    FEDERAL_FUNDS_RATE: [
      { label: 'Daily', value: 'daily' },
      { label: 'Weekly', value: 'weekly' },
      { label: 'Monthly', value: 'monthly' }
    ]
  };
  
  export const maturityOptions = [
    { label: '3 Month', value: '3month' },
    { label: '2 Year', value: '2year' },
    { label: '5 Year', value: '5year' },
    { label: '7 Year', value: '7year' },
    { label: '10 Year', value: '10year' },
    { label: '30 Year', value: '30year' }
  ];
  

  export const commodityOptions = [
    { name: 'Palladium Futures', code: 'XPDUSD:CUR' },
    { name: 'Gold', code: 'XAUUSD:CUR' },
    { name: 'Platinum', code: 'XPTUSD:CUR' },
    { name: 'Silver', code: 'XAGUSD:CUR' },
    { name: "Crude Oil Futures", code: "CL1:COM"},
    { name: "Brent Futures", code: "CO1:COM"},
    { name: "Natural Gas Futures", code: "NG1:COM"},
    { name: 'Gasoline Futures', code: 'XB1:COM' },
    { name: 'Sugar Futures', code: 'SB1:COM' },
    { name: 'Corn Futures', code: 'C_1:COM' },
    { name: 'Soybeans Futures', code: 'S_1:COM' },
    { name: 'Coffee Futures', code: 'KC1:COM' },
    { name: 'Wheat Futures', code: 'W_1:COM' },
    { name: 'Nickel Futures', code: 'LN1:COM' },
    { name: 'Aluminum', code: 'LMAHDS03:COM' },
    { name: 'Copper Futures', code: 'HG1:COM' },
    { name: 'Tin Futures', code: 'LMSNDS03:COM' },
    { name: 'Steel Futures', code: 'JBP:COM' },
    { name: 'Iron Ore Futures', code: 'SCO:COM' },
    { name: 'Industrial Metals - Invesco DB Base Metals Fund ETF', code: 'DBB' },
    { name: 'Diversified Commodities - Bloomberg Commodities Index', code: 'BCI' },
    { name: 'Agriculture - Invesco DB Agriculture Fund ETF', code: 'DBA' },
    { name: 'Energy - Invesco DB Energy Fund ETF', code: 'DBE' },
    { name: 'Diversified Commodities - Goldman Sachs Commodities Index', code: 'GSG' }
  ];
